import { useEffect } from 'react'

interface JsonLdProps {
  data: Record<string, unknown> | Record<string, unknown>[]
  id?: string
}

export default function JsonLd({ data, id = 'json-ld-data' }: JsonLdProps) {
  useEffect(() => {
    let script = document.getElementById(id) as HTMLScriptElement | null
    if (!script) {
      script = document.createElement('script')
      script.id = id
      script.type = 'application/ld+json'
      document.head.appendChild(script)
    }
    script.text = JSON.stringify(data)

    return () => {
      script?.remove()
    }
  }, [data])

  return null
}
